import { ListPlusIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const AddList = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <ListPlusIcon width={Sizes[size]} {...rest} color={fill} />;
};

AddList.displayName = 'AddList';
